<script>
  import { onMount, getContext, setContext } from 'svelte';
  import Route from 'route-parser';

  import Link from './link';
  import { active } from './route.store';
  import { session } from './session.store';

  const history = getContext('history');

  export let routes = [];

  let current;

  function parseRoute(pathname) {
    const route = routes.find(r => r.test.match(pathname));
    if (!route) {
      current = null;
      return;
    }
    current = {
      component: route.component,
      match: { params: route.test.match(pathname) }
    };

    active.update(n => {
      return { section: route.section, sub: route.sub };
    });
  }

  function createHistorySubscribers() {
    const location = history.location;

    routes = routes.map(route => {
      route.test = new Route(route.path);
      return route;
    });

    const unlisten = history.listen((location, action) => {
      window.scrollTo(0, 0);
      parseRoute(location.pathname);
    });

    parseRoute(location.pathname);
  }

  onMount(createHistorySubscribers);
</script>

<div class="routes">
  <!-- ROUTES -->
  {#if current}
  <svelte:component this="{current.component}" match="{current.match}" />
  {/if}
</div>
